module.exports = __webpack_public_path__ + "static/media/bluelab-conductivity-pen.0d486907.webp";